module.exports = __webpack_public_path__ + "img/Butterfly_00112.09edeea9.png";